// extracted by mini-css-extract-plugin
export default {"container":"Create_container__P3DLa","infoSpan":"Create_infoSpan__6DpqD","errorSpan":"Create_errorSpan__jTNnR","enterCode":"Create_enterCode__CC15v"};